<template>
	<div>
		<v-btn
			class="button"
			color="primary"
			outlined
			tile
			@click="isDialogOpen = true"
		>
			<p>Voir les radiologues agréés</p>
		</v-btn>

		<DialogBox
			v-model="isDialogOpen"
			hide-actions
			title="Radiologues agréés"
			width="500px"
		>
			<section>
				<div
					v-for="professional in structureProfessionalList"
					:key="professional.id"
				>
					<p>
						{{ `${professional.first_name} ${professional.last_name}` }}
					</p>
				</div>
			</section>
		</DialogBox>
	</div>
</template>

<script setup lang="ts">
	import { ref } from 'vue';
	import DialogBox from '@cnamts/vue-dot/src/elements/DialogBox';

	import { Professional } from '@/types/professional';

	defineProps<{
		structureProfessionalList: Professional[];
	}>();

	const isDialogOpen = ref(false);
</script>

<style lang="css" scoped>
p {
	margin: 0 !important;
}

.button {
	width: fit-content;
	padding: 5px;
	height: auto !important;
	max-width: 100%;
	white-space: normal;
}
</style>
